export type Latitude = number;
export type Longitude = number;
export type Coordinates = [Latitude, Longitude] | null;
export function toLngLatLike(coords: Coordinates | undefined): { lng: number; lat: number } {
    if (!coords) {
        return { lng: 0, lat: 0 };
    }
    return { lng: coords[1], lat: coords[0] };
}
export function fromLngLatLike(lngLat: { lng: number; lat: number }): Coordinates {
    return [lngLat.lat, lngLat.lng];
}